export default function OrganizationSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'The Vertex',
    url: 'http://cg91.cn/',
    description: 'Independent journalism for the curious mind — in-depth reporting at the intersection of technology, business, design, and culture.',
    email: 'hello@cg91.cn',
    telephone: '+1-212-555-0192',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '244 Madison Avenue',
      addressLocality: 'New York',
      addressRegion: 'NY',
      postalCode: '10016',
      addressCountry: 'US',
    },
    sameAs: ['http://cg91.cn/'],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}